import { FC } from "react";
import { Column, Row } from "../../../../containers";
import { styles } from "../styles";
import { navItemData } from "./data";
import NavItemIcon from "./nav-item-icon";
import { AlignItems, JustifyContent } from "../../../../containers/types";
import { Text } from "../../../../typography";
import { useThemeStore } from "../../../../../stores";
import { ArrowLeftIcon } from "../../../../../assets/icons";
import { useNavigate } from "react-router";

const NavItems: FC = () => {
  const theme = useThemeStore((state) => state.theme);
  const navigate = useNavigate();

  const goto = (link: string): void => {
    navigate(link);
  };

  return (
    <Column
      style={styles.navItemsContainer}
      gap={50}
      alignItems={AlignItems.Start}
    >
      {navItemData.map((navItem) => (
        <Row
          key={navItem.title}
          style={{ width: "calc(100% - 40px)", cursor: "pointer" }}
          justifyContent={JustifyContent.Between}
          props={{ onClick: () => goto(navItem.to) }}
        >
          <Row
            style={{ width: "100%" }}
            justifyContent={JustifyContent.Start}
            gap={40}
          >
            <NavItemIcon Icon={navItem.Icon} pathname={navItem.to} />
            <Text size={14} color={theme.textOnOverlay}>
              {navItem.title}
            </Text>
          </Row>
          <ArrowLeftIcon />
        </Row>
      ))}
    </Column>
  );
};

export default NavItems;
